/** A screen's keys in the editor's column order: View, Create & edit, Delete, then its own actions. */
export function screenPermissionKeys(screen) {
    return [...screen.basic, ...Object.keys(screen.actions ?? {})].map((action) => `${screen.module}:${action}`);
}
//# sourceMappingURL=screen-permission-keys.js.map